<div class="card step-card flex flex-column justify-content-between">
  <div class="flex flex-column align-items-center flex-grow-1" *ngIf="!asset">
    <div class="flex w-full justify-content-end">
      <button
        [label]="'select.asset' | transloco"
        (click)="displayAssetSelector = true"
        pButton
        pRipple
        class="sm:ml-2 mt-2 sm:mt-0"
        icon="pi pi-map-marker"
        iconPos="left"
        [disabled]="!('ROLE_ADMIN' | userHasRole)"
      ></button>
    </div>
    <div class="mt-7 font-italic text-center">
      <p>{{'empty.associatedAsset' | transloco}}</p>
    </div>
  </div>
  <div class="flex flex-column mb-2 flex-grow-1 pb-2 justify-content-between" *ngIf="asset">
    <div class="flex flex-column sm:flex-row justify-content-end">
      <button
        [label]="'misc.associateToDifferentAsset' | transloco"
        (click)="displayAssetSelector = true"
        pButton
        pRipple
        icon="pi pi-map-marker"
        iconPos="left"
        [disabled]="!('ROLE_ADMIN' | userHasRole)"
      ></button>
      <button
        [label]="'misc.disassociateFromAsset' | transloco"
        (click)="unselectAsset()"
        pButton
        pRipple
        class="sm:ml-2 mt-2 sm:mt-0"
        icon="pi pi-times"
        iconPos="left"
        [disabled]="!('ROLE_ADMIN' | userHasRole)"
      ></button>
    </div>
    <div class="md:hidden text-center mt-3">
      <p class="mb-0">
        {{'misc.deviceAssociatedToAsset' | transloco}}
        <a [href]="'assets/' + asset.uuid + '/details'" target="_blank">{{asset.alias}}</a>
      </p>
    </div>
    <div class="flex flex-grow-1 mt-3">
      <div id="map" class="rounded"></div>
      <div class="absolute z-5 hidden md:block" style="padding: 10px;">
        <div class="flex align-items-center px-2" style="height: 29px; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1); border-radius: 4px; background: white;">
          <p class="mb-0">
            {{'misc.deviceAssociatedToAsset' | transloco}}
            <a [href]="'assets/' + asset.uuid + '/details'" target="_blank">{{asset.alias}}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="onPreviousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          (click)="onNextStep()"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="onCancel()"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>
</div>
<app-asset-selector
  [(visible)]="displayAssetSelector"
  [tenant]="tenant"
  [organization]="organization"
  [actionButtons]="assetSelectorActions"
></app-asset-selector>
